import { render, staticRenderFns } from "./PaywallMarquee.vue?vue&type=template&id=3450d6d6&scoped=true"
import script from "./PaywallMarquee.vue?vue&type=script&lang=js"
export * from "./PaywallMarquee.vue?vue&type=script&lang=js"
import style0 from "./PaywallMarquee.vue?vue&type=style&index=0&id=3450d6d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3450d6d6",
  null
  
)

export default component.exports